module.exports = __webpack_public_path__ + "img/liuchengshenpi.d6ad22f0.png";